<template>
  <div id="bottom">
    <Link to="https://www.baidu.com" target="_blank">
        <Text type="secondary"></Text>
    </Link>

  </div>
</template>

<style scoped>
 @import url("index.less");
</style>